var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 314,
    viewBox: "0 0 314 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.07 136.27C303.2 66.5005 246.87 10.1705 177.1 1.30048C74.7605 -11.7095 -11.7095 74.7605 1.30048 177.1C10.1705 246.86 66.5005 303.2 136.26 312.07C238.61 325.08 325.08 238.61 312.07 136.26M156.68 294.641C79.4705 294.641 17.0705 231.21 18.7605 153.61C18.7805 153.59 18.7905 153.58 18.8105 153.56H144.03C144.25 147.25 149.4 142.19 155.76 142.19C162.12 142.19 167.27 147.25 167.49 153.56H293.34C293.8 153.56 294.22 153.37 294.56 153.1C294.59 154.29 294.65 155.48 294.65 156.67C294.65 232.86 232.88 294.63 156.69 294.63",
    fill: "#0DA0A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.611 226.93C154.701 268.16 108.141 228.96 106.171 227.25C102.281 223.87 96.3809 224.26 92.9709 228.15C89.5609 232.04 89.9609 237.96 93.8509 241.36C94.2409 241.71 120.741 264.35 157.711 264.35C176.211 264.35 197.341 258.67 219.121 241.7C223.201 238.52 223.931 232.64 220.751 228.56C217.571 224.48 211.691 223.75 207.611 226.93Z",
    fill: "#0DA0A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.23 204.36C130.28 204.36 138.27 202.27 146.59 196.48C150.83 193.53 151.88 187.69 148.92 183.45C145.97 179.21 140.14 178.15 135.89 181.12C123.05 190.05 114.33 183.39 112.67 181.92C108.91 178.45 103.05 178.64 99.5199 182.36C95.9599 186.12 96.1299 192.04 99.8799 195.6C104.11 199.6 112.6 204.37 123.24 204.37",
    fill: "#0DA0A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.05 204.36C196.1 204.36 204.09 202.27 212.41 196.48C216.65 193.53 217.7 187.69 214.74 183.45C211.79 179.21 205.96 178.15 201.71 181.12C188.87 190.05 180.15 183.39 178.49 181.92C174.73 178.45 168.87 178.64 165.34 182.36C161.78 186.12 161.95 192.04 165.7 195.6C169.93 199.6 178.42 204.37 189.06 204.37",
    fill: "#0DA0A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.4fb6632f23fb7307c63d127305f4ed35.svg";
export { ForwardRef as ReactComponent };